var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-check_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3F75FF",
    d: "m8.23 11.938 5.5-5.48a.68.68 0 0 1 .52-.218.758.758 0 0 1 .52.24c.154.152.23.326.23.52a.718.718 0 0 1-.23.52l-6 6a.729.729 0 0 1-1.062 0L5.23 11.043A.718.718 0 0 1 5 10.52c0-.195.076-.368.23-.521a.718.718 0 0 1 .52-.23c.194 0 .368.077.52.23l1.96 1.938Z"
  }))));
};
export default SvgIconCheck;